import Vuex from 'vuex';
import Vue from 'vue';


Vue.use(Vuex);
const state = {
  isAppLoaded: false,
  isHomeAnimActive: true,
  isMenuOpen: false,
  lang: localStorage.getItem('lang') || 'en',
  isModalOpen: false,
  animation: null,
  currentAnimation: null,
  isModalVideoOpen: false,
  videoModalSrc: null,
  isBlog: false,
  isCanvasVisible: false,
  isCanvasLoaded: false,
  isScrollTopVisible: false,
  modalQuestionName: '',
  isAccessibilityVisible: false,
  isPageContrasted: false,
  isPageFontBigger: false,
  showPARP: false,
  showPAIH: false,
  modalStaticVideoType: 'presentation', 
}
let player = null;
const mutations = {
  LOAD_ANIMATION(state, options) {
    fetch(options.link)
      .then((res) => res.json())
      .then((json) => {
        state.animation = json;
        player.setAnimation(json);
        if (options.cb) {
          options.cb();
        }
      });
  },
  SET_SCROLL_TOP_VISIBLE(state, flag) {
    state.isScrollTopVisible = flag;
  },
  CLEAR_GROUND(state) {
    player.clearGround();
  },
  HIDE_CANVAS(state) {
    player.hideScene();
    state.isCanvasVisible = false;
  },
  SHOW_CANVAS(state) {
    player.resetCamera();
    state.isCanvasVisible = true;
  },
  HOME_ANIM_FINISHED(state) {
    state.isHomeAnimActive = false;
  },
  PLAY_NEXT(state) {
    player.animationManager.playAnimation();
  },
  PLAY_FOREST_PRESENTATION(state, cb) {
    player.setOnPause(cb);
    player.forestClick();
  },
  PLAY_FARM_PRESENTATION(state, cb) {
    // player.resetCamera
    player.setOnPause(cb);
    player.farmClick();
  },
  PLAY_AIRPORT_PRESENTATION(state, cb) {
    // player.resetCamera
    player.setOnPause(cb);
    player.airportClick();
  },
  ADD_PRODUCTS_MOUSE_EVENTS(state, options) {
    // player.initMouseEvents(Object.assign{options, d:2});

  },

  FARM_MOUSE_HOVER(state) {
    player.farmMouseHover();
  },
  FARM_MOUSE_LEAVE(state) {
    player.farmMouseLeave();
  },

  AIRPORT_MOUSE_HOVER(state) {
    player.airportMouseHover();
  },
  AIRPORT_MOUSE_LEAVE(state) {
    player.airportMouseLeave();
  },

  FOREST_MOUSE_HOVER(state) {
    player.forestMouseHover();
  },
  FOREST_MOUSE_LEAVE(state) {
    player.forestMouseLeave();
  },

  ADD_HOME_MOUSE_EVENTS(state, options) {
    player.initMouseEvents(options);
  },
  CLEAR_HOME_MOUSE_EVENTS(state) {
    // player.clearMouseEvents();
  },
  SET_MOBILE_ACTIVE(state, options) {
    player.setMobileActive(options.ground, options.dir)
  },
  SHOW_GROUNDS(state) {
    // state.isHomeAnimActive = false;
    player.showGrounds();
  },
  INIT_CANVAS_PLAYER(state, options) {
    player = new Player(Object.assign(options, {
      animation: state.animation,
      init: () => {
        state.isCanvasVisible = true;
        state.isCanvasLoaded = true;
        // state.isAppLoaded = true;
      }
    }))
    window.player = player;
  },
  INIT_GROUNDS(state) {
    state.isAppLoaded = true;
    player.initGrounds();
  },
  SHOW_LOADER_FINISH(state, cb) {
    player.showLoaderFinish(cb);
  },
  LOAD_ANIMATION_OBJECTS(state, cb) {
    player.startDownload(cb)
  },
  TOGGLE_MENU(state) {
    state.isMenuOpen = !state.isMenuOpen;
    if (state.isMenuOpen) {
      state.isModalOpen = false;
      state.modalQuestionName = '';
    }
  },
  CLOSE_MENU(state) {
    if (state.isMenuOpen)
      state.isMenuOpen = false
  },
  SET_LANG(state, lang) {
    localStorage.setItem('lang', lang)
    Vue.config.lang = lang;
    state.lang = lang;
  },
  SET_MODAL(state, options) {
    state.isModalOpen = options.visible;
    state.isMenuOpen = false;
    state.modalQuestionName = options.questionName;
  },
  OPEN_VIDEO_MODAL(state, src) {
    state.isModalVideoOpen = true;
    state.videoModalSrc = src;
  },
  CLOSE_VIDEO_MODAL(state, src) {
    state.isModalVideoOpen = false;
    state.videoModalSrc = src;
  },
  TOGGLE_PAGE_CONTRAST(state) {
    state.isPageContrasted = !state.isPageContrasted;
  },
  TOGGLE_PAGE_FONT_SIZE(state) {
    state.isPageFontBigger = !state.isPageFontBigger;
  },
  SET_ACCESIBILITY(state, src) {
    console.log('src',src)
    console.log('state',state)
    state.isAccessibilityVisible = src;
  },
   SET_MODAL_STATIC_VIDEO_TYPE(state, type) {
    state.modalStaticVideoType = type;
  }
}

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js